const getHundredNumbers = () =>
	[...new Array(100)].map((_, index) => index + 1);

export default getHundredNumbers;
